// src/components/educationModal.js
import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Grid,
  IconButton,
  InputAdornment,
  FormControl,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import calendar from "../../assets/icon/calendarblack.png";
import { DateCp } from "../customerDetail/dateCp";
import dayjs from "dayjs";
export default function AddModal({
  activeSection,
  open,
  handleClose,
  onSave,
  editValue,
}) {
  const [educationData, setEducationData] = useState({
    valueName: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEducationData((prev) => ({ ...prev, [name]: value }));
  };
  useEffect(() => {
    if (open) {
      setEducationData({
        valueName: editValue || "",
      });
    }
  }, [open, editValue]);

  const handleAdd = () => {
    onSave({
      value: educationData.valueName,
    });
    handleClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth={false}
      PaperProps={{
        sx: {
          width: { xs: "95%", sm: 400 },
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          height: "auto",
          backgroundColor: "#C0BFFF",
          // padding: "10px 20px 10px 30px",
          padding: "16px 24px",
          fontFamily: "'Montserrat', sans-serif",
          borderRadius: "10px",
          fontSize: { xs: "12px", sm: "13px", md: "20px" },
          fontWeight: 500,
        }}
      >
        {activeSection
          ?.replace(/([A-Z])/g, " $1")
          ?.replace(/^./, (str) => str.toUpperCase())}
        <IconButton onClick={handleClose} sx={{}}>
          <CloseIcon sx={{ fontSize: "25px" }} />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ p: 2 }}>
        <Grid container spacing={2} sx={{ mt: 0 }}>
          <Grid item xs={12} md={12}>
            <TextField
              label={`Add ${activeSection
                ?.replace(/([A-Z])/g, " $1")
                ?.replace(/^./, (str) => str.toUpperCase())}`}
              name="valueName"
              value={educationData.valueName}
              onChange={handleChange}
              fullWidth
              size="small"
              multiline // Makes the TextField act as a textarea
              rows={8}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions
        sx={{
          justifyContent: "center",
          p: 2,
        }}
      >
        <Button variant="contained" onClick={handleAdd} fullWidth>
          {editValue ? "Update" : "Add"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
